<template>
    <div id="requestPasswordReset" v-if="mail == null">
        <patternlib-headline :headline="$t('requestPasswordReset.headline')" heading-tag="h2" separator="none" />
        <p style="margin-top: var(--spacing-6);">{{ $t("requestPasswordReset.text") }}</p>
        <patternlib-textinput 
            style="margin-top: var(--spacing-6); max-width: 686px;"
            :label="$t('requestPasswordReset.label')"
            :placeholder="$t('requestPasswordReset.placeholder')"
            ref="mail"
        />
        <patternlib-button 
            style="margin-top: var(--spacing-6);"
            :label="$t('requestPasswordReset.headline')"
            :onclick="sendMail"
            :loading="loading"
        />
    </div>
    <RequestPasswordResetMailSent :mail="mail" v-if="mail != null"/>
</template>

<script>
import RequestPasswordResetMailSent from "./RequestPasswordResetMailSent.vue"
import { useServices } from "../services/useServices";
import { useGlobal } from "../stores/globalStore";

export default {
    data: () => ({
        mail: null,
        loading: false
    }),

  components: {
    RequestPasswordResetMailSent
  },

  methods: {
    sendMail() {
        this.loading = true
        let mail = this.$refs.mail.value
        const services = useServices()
        const globalStore = useGlobal()
        services.$api.requestPasswordReset((successfull) => {
            if (successfull) {
                this.mail = mail
            }
            this.loading = false
        }, mail, globalStore.language, globalStore.country)

    }
   }
}

</script>

<style lang="scss" scoped>
#requestPasswordReset {
    margin: 64px;
}

</style>